import styled from 'styled-components';
import {StyledDiv} from './StyledSx';

export default styled(StyledDiv)`
  display: flex;
  gap: 20px;
  row-gap: 80px;
  flex-wrap: wrap;
  a {
    text-decoration: underline;
  }
`;
